import React, { useState } from "react";
import './c91_profile_card_with_modal.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { insertHtml } from "../../utils/dom";

class ProfileCardWithModal extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            btnHidden: '',
            dataIndex: null,
            disabled: false,
            slideIndex: 1,
            updateCount: 0
        };

        this.requireInternationalization = true;
    };

    internationalComponentRender(data, t) {

        const [isActive, setIsActive] = useState(false);

        const handleClick = (event, param, name) => {
            setIsActive(current => !current);
            const el = document.getElementById(`card-modal_` + param + "_" + name);
            const modalbkg = document.getElementById('modal-background');
            el.style.setProperty('display', !isActive ? 'block' : 'none');
            modalbkg.style.setProperty('opacity', !isActive ? '1' : '0');
            modalbkg.style.setProperty('visibility', !isActive ? 'visible' : 'hidden');
        };

        return (<div id="profilecardwithmodal" className="container-fluid">
            <div className="modal-background" id="modal-background"></div>
            {data.title.length > 0 ?
                <div className="title">
                    {data.title}
                </div>
                :
                null}
            <div className="row card-row">
                {data.item.length > 0 ? data.item.map((person, index) =>
                    <>
                        <div className="card-container">
                            {person.bio ?
                                <a key={index} className="no-style" onClick={event => handleClick(event, index, person.name.replace(/\s/g, ""))}>
                                    <div className="card card-hover" id={`card_` + index + '_' + person.name.replace(/\s/g, "")}>
                                        <div className="img-container">
                                            {person.photo ? <img className="image-card" src={person.photo} alt="Luiss.it" /> : null}
                                        </div>
                                        <div className="major-props overlay" />
                                        <div className="major-props majors">
                                            <button className="button-bio">BIO</button>
                                        </div>
                                    </div>
                                </a>
                                :
                                <div key={index} className="no-style">
                                    <div className="card" id={`card_` + index + '_' + person.name.replace(/\s/g, "")}>
                                        <div className="img-container">
                                            {person.photo ? <img className="image-card" src={person.photo} alt="Luiss.it" /> : null}
                                        </div>
                                    </div>
                                </div>}
                            <h5 className="name">{person.name}</h5>
                            <h6 className="description">{person.position}</h6>
                        </div>
                        <div className={`card-modal`} id={`card-modal_` + index + '_' + person.name.replace(/\s/g, "")}>
                            <button className="card-modal-btn" onClick={event => handleClick(event, index, person.name.replace(/\s/g, ""))}>&times; {data.langcode === 'it' ? `Chiudi` : `Close`}</button>
                            <div className="container-fluid">
                                <div className="row first-row">
                                    <div className="col-12 col-sm-5 col-md-4 col-lg-3">
                                        {person.photo ? <img className="card-modal-image" src={person.photo} alt="Luiss.it" /> : null}
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-4 col-lg-4 col-modal-info">
                                        <h5 className="modal-name">{person.name}</h5>
                                        <h6 className="modal-description">{person.position}</h6>
                                        {person.linkedin ?
                                            <a className="linkedIn-container" href={person.linkedin}>
                                                <img src="/linkedin.png" alt='' />
                                            </a> : null}
                                        {person.email ?
                                            <a className="email-container" href={`mailto:` + person.email}>
                                                <img src="/email.png" alt='' />
                                            </a> : null
                                        }
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4 col-lg-5 col-modal-info">
                                        <p className="modal-info">
                                            {person.location ? <><span className="blue-span">Campus Sede:</span> {person.location} </> : null}
                                            <br />
                                            {person.public_contact ? <><span className="blue-span">Contatto:</span> {person.public_contact} </> : null}
                                            <br />
                                            {person.secretary ? <><span className="blue-span">Segreteria:</span> {person.secretary} </> : null}
                                        </p>
                                    </div>
                                </div>
                                <div className="row second-row">
                                    <div className="col-12">
                                        <p className="modal-text" {...insertHtml(person.bio)}></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>) : <div className={'row not-found mt-5'}>{data.langcode === 'it' ? "Non ci sono elementi disponibili" : "No available items"}</div>}
            </div>
        </div>)
    }
}

export default ProfileCardWithModal;
